const translations: Record<string, string> = {
  "ak_dsp4_above_the_rated_power_kw": "Above the rated power ({{p}} kW)",
  "ak_dsp4_hr_power_kw_is_above_the_rated_power_k": "Hr {{hh}}: power {{p}} kW is above the rated power ({{max}} kW)",
  "ak_dsp4_below_pmin_kw": "Below Pmin {{p}} kW",
  "ak_dsp4_charge": "charge",
  "ak_dsp4_discharge": "discharge",
  "ak_dsp4_hr_kw_is_below_the_minimum_operating_p": "Hr {{hh}}: {{mode}} {{p}} kW is below the minimum operating power {{pmin}} kW - the unit will not execute such a command (short by {{miss}} kW). Combine these hours into fewer full ones.",
  "ak_dsp4_overcharge_kwh_free": "Overcharge: {{r}} kWh free",
  "ak_dsp4_hr_charge_kwh_does_not_fit_at_soc_ther": "Hr {{hh}}: charge {{p}} kWh does not fit - at SOC {{soc}}% there are {{room}} kWh left to the {{max}}% ceiling (excess {{over}})",
  "ak_dsp4_below_the_limit_kwh_available": "Below the {{min}}% limit: {{a}} kWh available",
  "ak_dsp4_hr_discharge_kwh_takes_the_bess_below": "Hr {{hh}}: discharge {{p}} kWh takes the BESS below the working {{min}}% - at SOC {{soc}}% {{a}} kWh is available (short by {{miss}})",
  "ak_dsp4_kw": "kW",
  "ak_dsp4_kwh": "kWh",
  "ak_dsp4_working_range": "· working range {{a}}–{{b}}%",
  "ak_dsp4_can_charge": "Can charge:",
  "ak_dsp4_can_discharge": "Can discharge:",
  "ak_dsp4_soc_at_end_of_day": "SOC at end of day:",
  "ak_dsp4_charge_losses_discharge_at_the_connect": "charge ×{{c}} (losses) · discharge ÷{{d}} at the connection point",
  "ak_dsp4_command_from_kw": "command from {{p}} kW",
  "ak_dsp4_and_more": "…and {{n}} more",
  "ak_dsp4_solar_charge_discharge": "Solar {{pv}} · Charge −{{ch}} · Discharge +{{dis}} ·",
  "ak_dsp4_total_mwh": "Total {{n}} MWh",
  "ak_dsp4_mwh": "MWh",
  "ak_dsp4_bess_schedule_saved_the_net_forecast_h": "BESS schedule saved - the net forecast has been updated.",
  "ak_dsp4_failed_to_save": "Failed to save",
  "ak_dsp4_schedule_proposed_review_and_save_it": "Schedule proposed - review and save it.",
  "ak_dsp4_autofill_unavailable": "Autofill unavailable",
  "ak_dsp4_bess_charge_discharge_schedule": "BESS charge/discharge schedule",
  "ak_dsp4_charging_reduces_discharging_increases": "Charging reduces, discharging increases the net forecast",
  "ak_dsp4_bess_charge_at_start_of_day": "BESS charge at start of day:",
  "ak_dsp4_bess_charge_now": "BESS charge now:",
  "ak_dsp4_no_telemetry": "no telemetry",
  "ak_dsp4_from_telemetry_history": " (from telemetry history)",
  "ak_dsp4_stale": " (stale)",
  "ak_dsp4_pcs_in_fault": " (PCS in fault)",
  "ak_dsp4_autofill_propose_a_schedule_automatica": "Autofill: propose a schedule automatically",
  "ak_dsp4_save_bess_schedule": "Save BESS schedule",
  "ak_dsp4_collapse_hourly_data": "Collapse hourly data",
  "ak_dsp4_hourly_data": "Hourly data",
  "ak_dsp4_start_soc": "Start SOC",
  "ak_dsp4_restore_telemetry": "restore telemetry",
  "ak_dsp4_technically_impossible_values_fix_them": "Technically impossible values - fix them to save:",
  "ak_dsp4_the_bess_balance_does_not_add_up_for_a": "The BESS balance does not add up - for a past day this is only a warning, saving is allowed",
  "ak_dsp4_charge_2": "Charge",
  "ak_dsp4_discharge_2": "Discharge",
  "ak_dsp4_net_forecast_solar_generation_bess": "Net forecast (solar generation + BESS)",
  "ak_dsp4_solar_generation": "Solar generation",
  "ak_dsp4_bess_discharge": "BESS discharge",
  "ak_dsp4_bess_charge": "BESS charge",
  "ak_dsp4_net": "Net",
  "ak_dsp4_hr": "Hr",
};

export default translations;
